import { useRef } from 'react';
import Paso from '@/components/Paso';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useIsomorphicLayoutEffect } from '@/helpers/isomorphicEffect';

gsap.registerPlugin(ScrollTrigger);

const Valor = ({ number, title, text, bgColor }) => {
  const root = useRef(null);

  useIsomorphicLayoutEffect(() => {
    if (!root.current) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: root.current,
        start: 'top 70%',
        toggleActions: 'play none none none'
      }
    });

    tl.fromTo(root.current.querySelector('.paso-js'),
      { autoAlpha: 0, scale: 0 },
      { autoAlpha: 1, scale: 1, duration: 0.6, ease: 'back.out' }, 0);
    tl.fromTo(root.current.querySelector('.title-js'),
      { autoAlpha: 0, xPercent: 20 },
      { autoAlpha: 1, xPercent: 0, duration: 0.6 }, 0);
    tl.fromTo(root.current.querySelector('.text-js'),
      { autoAlpha: 0, xPercent: 20 },
      { autoAlpha: 1, xPercent: 0, duration: 0.6 }, 0);

    const refresh = () => ScrollTrigger.refresh();
    const ids = [
      requestAnimationFrame(refresh),
      setTimeout(refresh, 100),
      setTimeout(refresh, 500),
      setTimeout(refresh, 1500)
    ];
    document.fonts?.ready?.then(refresh);
    window.addEventListener('load', refresh);

    return () => {
      cancelAnimationFrame(ids[0]);
      clearTimeout(ids[1]);
      clearTimeout(ids[2]);
      clearTimeout(ids[3]);
      window.removeEventListener('load', refresh);
      tl.scrollTrigger?.kill();
      tl.kill();
    };
  }, []);

  return (
    <div ref={root} className="relative flex items-start justify-start">
      <div className="origin-center mr-21 paso-js">
        <Paso bgColor={bgColor} number={number} />
      </div>
      <div className="flex flex-col sm:flex-row items-start">
        <div className="sm:w-225 mb-16 sm:mb-0 sm:mr-50 title-js">
          <h3 className="title-3">{title}</h3>
        </div>
        <div className="max-w-[46.5rem] text-js">
          <p className="p1 !text-14 sm:!text-16 text-cyan-dark">{text}</p>
        </div>
      </div>
    </div>
  );
};
export default Valor;
